import "./header.css";
import { BsList } from "react-icons/bs";
import Dropdown from "../dropdown/Dropdown";
import { Link } from "react-router-dom";
import { useDispatch } from 'react-redux';
import { useGetLoggedUserQuery } from '../../services/userCRUDApi';
import { useEffect, useState } from 'react';
import { setUserInfo } from '../../features/userSlice';
import user_image from "../header/UserAfatar.jpg";

const user_menu = [
  {
    content: "Dashboard",
    path: "/admin/dashboard",
  },
  {
    content: "Profile",
    path: "/admin/profile",
  },
  {
    content: "Logout",
    path: "/logout",
  },
];

const renderUserToggle = (user) => (
  <div className="topnav__right-user">
    <div className="topnav__right-user__image">
      <img src={user_image} alt="" />
    </div>
    <div className="topnav__right-user__name">{user.first_Name} {user.last_Name}</div>
  </div>
);

const renderUserMenu = (item, index) => (
  <Link to={item.path} key={index} role="menuitem">
    <div className="userMenue-item">
      <span>{item.content}</span>
    </div>
  </Link>
);

const Header = ({ onToggleCollapse }) => {
  const dispatch = useDispatch()
  const { data, isSuccess } = useGetLoggedUserQuery()

  const [userData, setUserData] = useState({
      id:"",
      first_Name: "",
      last_Name: "",
      email: "",
      type: "",
  })

  // Store User Data in Local State
  useEffect(() => {
    if (data && isSuccess) {
      setUserData({
        id: data.id,
        first_Name: data.first_Name,
        last_Name: data.last_Name,
        email: data.email,
        type: data.type,
      })
    }
  }, [data, isSuccess])

  // Store User Data in Redux Store
  useEffect(() => {
    if (data && isSuccess) {
      dispatch(setUserInfo({
        id: data.id,
        first_Name: data.first_Name,
        last_Name: data.last_Name,
        email: data.email,
        type: data.type,
      }))
    }
  }, [data, isSuccess, dispatch])

  return (
    <header className="header">
      <div className="content">
        <div className="headerLeft">
          <button type="button" className="headerMenuBtn" onClick={onToggleCollapse} aria-label="Toggle sidebar">
            <BsList />
          </button>
          {/* Persistent chrome text, not a content heading - AdminPageHeader
              on the actual page provides the real h1 for each route, and
              this rendering above it as an <h3> broke heading order on
              every single page in the app. */}
          <span className="headerWelcome">Welcome back, {userData.first_Name}</span>
        </div>
        <div className="headerRight">
          <div className="headerItems">
            <Dropdown
              customToggle={() => renderUserToggle(userData)}
              contentData={user_menu}
              renderItems={(item, index) => renderUserMenu(item, index)}
            />
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
